import React, { FC } from 'react';
import { View, Text } from 'react-native';
import TouchableElement from '@components/common/touchableElement';
import i18n from 'i18n-js';
import { font as initialFont } from '@styles/fonts';
import { scale as initialScale } from '@components/frame';
import { ColorFunction } from '@styles/colors/types';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { SmallLoading } from '@components/loading';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';
import { ContainerStyle } from '@interfaces/base';

export interface NoDataProps extends ContainerStyle {
  C: ColorFunction;
  loaded: boolean;
  lineSize: number;
  scale?: ScaleFunction;
  font?: typeof initialFont;
}

const NoData: FC<NoDataProps> = ({
  C,
  loaded,
  lineSize,
  scale = initialScale,
  font = initialFont,
  containerStyle
}) => {
  return (
    <TouchableElement hitSlop={{ top: 0, bottom: 0, left: 0, right: 0 }}>
      {({ boxStyle, pressHoverColor }) => (
        <View
          style={[
            {
              flex: 1,
              borderBottomColor: C('Hairline/Light/No trans'),
              paddingRight: scale(30),
              paddingLeft: scale(15),
              flexDirection: 'row',
              minHeight: scale(lineSize),
              height: scale(lineSize),
              backgroundColor: C(pressHoverColor('Background / Light / Field')),
              zIndex: 1,
              justifyContent: 'center',
              alignContent: 'center',
              alignItems: 'center',
              borderBottomWidth: 0,
              borderBottomRightRadius: scale(SCREEN_BORDER_RADIUS),
              borderBottomLeftRadius: scale(SCREEN_BORDER_RADIUS),
            },
            boxStyle,
            containerStyle,
          ]}
        >
          {loaded ? (
            <Text
              style={[
                font['Button 2'],
                {
                  color: C('Label/Light/Primary'),
                  width: '100%',
                  textAlign: 'center',
                },
              ]}
            >
              {i18n.t('No data')}
            </Text>
          ) : (
            <View style={{ marginTop: scale(20) }}>
              <SmallLoading />
            </View>
          )}
        </View>
      )}
    </TouchableElement>
  );
};

export default NoData;
